export const userData = [
  {
    _id: '64930dfff9d66e79ba263490',
    name: 'rishabh5',
    email: 'rishabh5@mail.com',
    phone: 123456,
  },
  {
    _id: '64934208b9ce851f314c8fb4',
    name: 'rishabh566',
    email: 'rishabh56@mail.com',
    phone: 12345678,
  },
];
